type EventCallback = (...args: any[]) => void;

export enum GameEvent {
  BEAT = 'BEAT',
  EQUIPMENT_PLACED = 'EQUIPMENT_PLACED',
  EQUIPMENT_REMOVED = 'EQUIPMENT_REMOVED',
  COVERAGE_UPDATED = 'COVERAGE_UPDATED',
  BUDGET_CHANGED = 'BUDGET_CHANGED',
  SATISFACTION_CHANGED = 'SATISFACTION_CHANGED',
  BUILD_MODE_CHANGED = 'BUILD_MODE_CHANGED',
  RAVER_COUNT_CHANGED = 'RAVER_COUNT_CHANGED',
  SIMULATION_TICK = 'SIMULATION_TICK',
  TOGGLE_MUTE = 'TOGGLE_MUTE',
  MUTE_CHANGED = 'MUTE_CHANGED',
  MUSIC_STOP = 'MUSIC_STOP',
  MUSIC_RESUME = 'MUSIC_RESUME',
  FPS_MODE_ENTERED = 'FPS_MODE_ENTERED',
  FPS_MODE_EXITED = 'FPS_MODE_EXITED',
  SPECIAL_CHAR_SPEECH = 'SPECIAL_CHAR_SPEECH',
  EQUIPMENT_MOVED = 'EQUIPMENT_MOVED',
}

class EventBusClass {
  private listeners: Map<string, Set<EventCallback>> = new Map();

  on(event: string, callback: EventCallback): void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event)!.add(callback);
  }

  off(event: string, callback: EventCallback): void {
    this.listeners.get(event)?.delete(callback);
  }

  emit(event: string, ...args: any[]): void {
    this.listeners.get(event)?.forEach((cb) => cb(...args));
  }

  clear(): void {
    this.listeners.clear();
  }
}

export const EventBus = new EventBusClass();
